import React, {useState, useEffect, useRef} from 'react';
import 'react-multi-carousel/lib/styles.css';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';

import NoraHomepage from '../../images/homepage/nora-homepage.png';

import UNITEDAIRLINES from '../../images/homepage/unitedAirlines.png';
import EMIRATES from '../../images/homepage/emiratesAirlines.png';
import DELTA from '../../images/homepage/deltaAirlines.png';
import TURKISHAIRLINES from '../../images/homepage/turkishAirlines.png';
import KLM from '../../images/homepage/klm.png';
import ALASKA from '../../images/homepage/alaskaAirlines.png';
import AMERICANAIRLINES from '../../images/homepage/americanAirlines.png';
import SOUTHWESTAIRLINES from '../../images/homepage/southwestAirlines.png';
import RYANAIR from '../../images/homepage/ryanAir.png';
import LUFTHANSA from '../../images/homepage/lufthansaAirlines.png';
import HAWAIIANAIRWAYS from '../../images/homepage/hawaiianAirlines.png';
import AIRFRANCE from '../../images/homepage/airFrance.png';
import ETIHAD from '../../images/homepage/etihadAirlines.png';
import QATARAIRWAYS from '../../images/homepage/qatarAirways.png';
import INDIGO from '../../images/homepage/indigo.png';
import FLYDUBAI from '../../images/homepage/flyDubai.png';
import JETBLUE from '../../images/homepage/jetBlue.png';
import AIRCANADA from '../../images/homepage/airCanada.png';
import QANTAS from '../../images/homepage/qantas.png';

import NoraFeatures1 from '../../images/homepage/norafeatures1.png';
import NoraFeatures2 from '../../images/homepage/norafeatures2.png';
import NoraFeatures3 from '../../images/homepage/norafeatures3.png';
import NoraFeatures4 from '../../images/homepage/norafeatures4.png';

import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useMediaQuery } from '@mui/material';

import Review10 from "../../images/homepage/review10.png";
import Review11 from "../../images/homepage/review11.png";
import Review12 from "../../images/homepage/review12.png";
import Review13 from "../../images/homepage/review13.png";
import Review14 from "../../images/homepage/review14.png";
import Review15 from "../../images/homepage/review15.png";

import Container from "../../images/homepage/container.png";
import ContainerMobile from "../../images/homepage/containerMobile.png";

import CompanyCards from '../../components/CompanyCards3';
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

SwiperCore.use([Pagination]);

function FlightAttendantHomeScreen({ loginState }) {
    let navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');

    const [loading, setLoading] = useState(false);
    const { referrerId, name } = useParams();

    useEffect(() => {
        if (referrerId) {
            localStorage.setItem("referredBy", referrerId);
        }
    }, [referrerId]);

    const [openIndex, setOpenIndex] = useState(null);
    const faqRefs = useRef([]);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    useEffect(() => {
        const isMobile = window.innerWidth <= 600;
        faqRefs.current.forEach((ref, idx) => {
            if (ref) {
                if (openIndex === idx) {
                    const contentHeight = ref.scrollHeight;
                    ref.style.maxHeight = `${contentHeight}px`;
                    
                    if (isMobile) {
                        const basePadding = 165;
                        const extraPadding = Math.min(contentHeight * 0.1, 100);
                        const totalPadding = basePadding + extraPadding;
                        ref.style.padding = `0 20px ${totalPadding}px`;
                    } else {
                        ref.style.padding = '0 20px 70px';
                    }
                } else {
                    ref.style.maxHeight = '0';
                    ref.style.padding = '0 20px';
                }
            }
        });
    }, [openIndex]);
    
    const faqs = [
        {
            question: "Does Nora have questions specific to flight attendant interviews?",
            answer: "Yes — Nora has interview questions tailored specifically to flight attendant and cabin crew roles. That includes passenger scenario questions, behavioral situations, and the kind of questions major airlines recruiters actually ask."
        },
        {
            question: "Can Nora help me prepare for the Open Day or group exercise format?",
            answer: "Nora is best for practicing your individual interview answers — behavioral questions, self-introductions, and passenger scenarios. It won't simulate a full group exercise, but it'll get your individual responses sharp before you walk in."
        },
        {
            question: "Does Nora handle non-native speakers or users with accents?",
            answer: "Nora is designed to understand a variety of accents and speech patterns - you'll have an awesome experience regardless :)"
        },
        {
            question: "Can I track my progress and compare different interview sessions?",
            answer: "Yep, you sure can! Nora lets you look back at each mock interview, track your progress, and compare how you've done over time. It's a great way to see what's improving and what might still need some work."
        },
        {
            question: "How much does Nora cost?",
            answer: "First mock interview & feedback is free. After that, it's $15/month for unlimited mock interviews and feedback!"
        }
    ];

    const [isVisible, setIsVisible] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const toggleVisibility = () => {
            const scrolled = document.documentElement.scrollTop;
            const maxHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrollPercentage = (scrolled / maxHeight) * 100;
        
            if (scrolled > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
            setScrollProgress(scrollPercentage);
        };
    
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <>
        <Helmet>
            <title>Flight Attendant Interview Prep & Practice Questions | Nora AI</title>
            <meta name="description" content="Practice flight attendant interviews with Nora AI. Real cabin crew behavioral questions, passenger scenarios, AI mock interviews, and instant feedback to help you ace your airline interview." />
            <meta name="keywords" content="flight attendant interview prep, cabin crew interview practice, Emirates interview questions, United Airlines flight attendant interview, AI mock interview for flight attendants, behavioral interview aviation, airline interview preparation" />
            <link rel="canonical" href="https://interview.norahq.com/flight-attendant" />

            {/* Open Graph */}
            <meta property="og:title" content="Flight Attendant Interview Prep & Practice Questions | Nora AI" />
            <meta property="og:description" content="Practice flight attendant interviews with Nora AI. Real cabin crew behavioral questions, passenger scenarios, AI mock interviews, and instant feedback to help you ace your airline interview." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://interview.norahq.com/flight-attendant" />
            <meta property="og:image" content="https://interview.norahq.com/images/logo/nora-ai-logo.png" />

            {/* Organization Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Nora AI",
                "url": "https://interview.norahq.com/flight-attendant",
                "logo": "https://interview.norahq.com/images/logo/nora-ai-logo.png",
                "description": "AI mock interviewer helping flight attendants and cabin crew prepare for airline interviews with real behavioral questions and personalized feedback",
                "sameAs": [
                "https://www.linkedin.com/company/norahq",
                "https://www.instagram.com/trynorahq/",
                "https://www.tiktok.com/@norahq"
                ]
            })}</script>

            {/* Website Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "Nora AI",
                "url": "https://interview.norahq.com/flight-attendant",
                "description": "AI-powered mock interview platform for flight attendant and cabin crew interview preparation",
                "potentialAction": {
                "@type": "SearchAction",
                "target": "https://interview.norahq.com/search?q={search_term_string}",
                "query-input": "required name=search_term_string"
                }
            })}</script>

            {/* SoftwareApplication Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "SoftwareApplication",
                "name": "Nora AI",
                "description": "AI-powered interview preparation platform for flight attendants and cabin crew with real airline questions and personalized feedback",
                "url": "https://interview.norahq.com/flight-attendant",
                "applicationCategory": "Educational Software",
                "operatingSystem": "Web Browser",
                "offers": {
                "@type": "Offer",
                "price": "15",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
                }
            })}</script>

            {/* Service Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Service",
                "name": "Nora AI Mock Interviewer for Flight Attendants",
                "description": "AI mock interview platform for flight attendants and cabin crew. Practice real airline behavioral questions and passenger scenarios with personalized feedback after every session.",
                "provider": {
                "@type": "Organization",
                "name": "Nora AI"
                },
                "serviceType": "Interview Preparation",
                "offers": {
                "@type": "Offer",
                "availability": "https://schema.org/InStock",
                "price": "0",
                "priceCurrency": "USD"
                }
            })}</script>
        </Helmet>
        <div className='homepage'>
            {loading && (
                <div className="loader3">
                    <div className="loader2"></div>
                </div>
            )}

            {/* ── HERO SECTION ── */}
            <div className={isMobile ? "landing landing-mobile" : "landing"}>
                <div className="left-container">
                    <div className="badge-pill">
                        <span className="badge-plus">+</span> The #1 AI Mock Interviewer
                    </div>

                    <h1>
                        {name ? (
                            <>
                            {decodeURIComponent(name).replace(/^\w/, c => c.toUpperCase())}, invited you to Nora AI.
                            <br />
                            Get 25% off our paid plan 😀
                            </>
                        ) : (
                            <>
                            Practice Interviews
                            <br />
                            for <span className="rotating-role" style={{ color: '#7D994D' }}> Flight Attendants </span>
                            </>
                        )}
                    </h1>

                    <p>
                        Interview coming up? Sharpen your skills with AI-powered interview sessions and feedback actually built for flight attendants.
                    </p>

                    {!loginState.loggedIn && (
                        <button
                            className="nora-landing-cta"
                            onClick={() => name
                                ? navigate("/login", {
                                    state: {
                                        referredFrom: referrerId || null,
                                        userReferred: true
                                    }
                                })
                                : navigate("/login")
                            }
                        >
                            {name ? "Accept Invitation" : "Practice with Nora Mock Interviewer"} &nbsp;→
                        </button>
                    )}

                    <div className="social-proof">
                        <div className="social-proof-row">
                            <div className="avatar-group">
                                <img src={Review10} alt="user" className="avatar-img" />
                                <img src={Review11} alt="user" className="avatar-img" />
                                <img src={Review13} alt="user" className="avatar-img" />
                                <img src={Review15} alt="user" className="avatar-img" />
                            </div>
                            <span className="social-proof-text">
                                Join <strong>10,800+</strong> candidates practicing
                            </span>
                        </div>
                        <a href="https://www.norahq.com" className="social-proof-link">
                            Hiring team? See AI Screening
                        </a>
                    </div>
                </div>

                {!isMobile && (
                    <div className="right-container">
                        <img
                            src={NoraHomepage}
                            alt="Nora AI Mock Interviewer in action"
                            className="hero-image"
                        />
                    </div>
                )}
            </div>

            {/* Mobile-only hero image */}
            {isMobile && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 16px 0' }}>
                    <img
                        src={NoraHomepage}
                        alt="Nora AI Mock Interviewer in action"
                        style={{ maxWidth: '95%' }}
                    />
                </div>
            )}

            {/* Logo slider */}
            <div className="logo-slider">
                {/* <h2 className="companies-header">Companies Our Users Have Received Offers From</h2> */}
                <p className="companies-header">
                    Companies Our Users Have Received Offers From
                </p>
                <div className="logo-track">
                    {[...Array(2)].map(() => (
                        <>
                            <div className="logo-item">
                                <img src={UNITEDAIRLINES} alt="United Airlines" />
                            </div>
                            <div className="logo-item">
                                <img src={EMIRATES} alt="Emirates" />
                            </div>
                            <div className="logo-item">
                                <img src={DELTA} alt="Delta Airlines" />
                            </div>
                            <div className="logo-item">
                                <img src={TURKISHAIRLINES} alt="Turkish Airlines" />
                            </div>
                            <div className="logo-item">
                                <img src={KLM} alt="KLM Airlines" />
                            </div>
                            <div className="logo-item">
                                <img src={ALASKA} alt="Alaska Airlines" />
                            </div>
                            <div className="logo-item">
                                <img src={AMERICANAIRLINES} alt="American Airlines" />
                            </div>
                            <div className="logo-item">
                                <img src={SOUTHWESTAIRLINES} alt="Southwest Airlines" />
                            </div>
                            <div className="logo-item">
                                <img src={RYANAIR} alt="Ryan Air" />
                            </div>
                            <div className="logo-item">
                                <img src={LUFTHANSA} alt="Lufthansa Airlines" />
                            </div>
                            <div className="logo-item">
                                <img src={HAWAIIANAIRWAYS} alt="Hawaiian Airways" />
                            </div>
                            <div className="logo-item">
                                <img src={ETIHAD} alt="Etihad Airways" />
                            </div>
                            <div className="logo-item">
                                <img src={QATARAIRWAYS} alt="Qatar Airways" />
                            </div>
                            <div className="logo-item">
                                <img src={INDIGO} alt="Indigo" />
                            </div>
                            <div className="logo-item">
                                <img src={FLYDUBAI} alt="Fly Dubai" />
                            </div>
                            <div className="logo-item">
                                <img src={JETBLUE} alt="Jet Blue" />
                            </div>
                            <div className="logo-item">
                                <img src={AIRCANADA} alt="Air Canada" />
                            </div>
                            <div className="logo-item">
                                <img src={QANTAS} alt="Qantas Airlines" />
                            </div>
                        </>
                    ))}
                </div>
            </div>

            <div className="outsourcing-solution" id="how-it-works">
                <h2 className="outsourcing-heading">How Nora Works - <span style={{ color: '#7D994D' }}> It's Simple. </span> </h2>
                <p className="outsourcing-description">
                    3 simple steps to level up your interview game
                </p>
            </div>

            <div className="how-it-works-1-partnership">
                <img src={isMobile ? ContainerMobile : Container} alt="Feedback" id="feedback-picture" className='image2-styling' />
            </div>

            <div className="outsourcing-solution">
                <h2 className="outsourcing-heading">Watch Nora in Real Time</h2>
                <p className="outsourcing-description" style={{ marginBottom: '50px' }}>
                    Watch how Nora works in real life, and can offer valuable interview practice.
                </p>
                <iframe
                    width={isMobile ? "380" : "640"}
                    height={isMobile ? "214" : "360"}
                    src="https://www.youtube.com/embed/7u0Rf3D_jN0?si=wlmJwsxo5_QjGrrl"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                </iframe>
            </div>

            <div className="outsourcing-solution" id="how-it-works" style={{ marginTop: isMobile ? '30%' : '7%' }}>
                <h2 className="outsourcing-heading">The last <span style={{ color: '#7D994D' }}> Mock Interview </span> you'll ever need </h2>
                <p className="outsourcing-description">
                    Real company questions, a mock interview that actually feels like the real thing, and feedback that doesn't sugarcoat
                </p>
            </div>

            <div className="features-grid-section">
                <div className="features-grid">
                    <div className="feature-card">
                        <img src={NoraFeatures1} alt="Real Interview Questions" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>Real Questions from the Real World</h3>
                            <p>We simulate reality by sourcing the latest questions from across the internet and our vetted database.</p>
                        </div>
                    </div>
                    <div className="feature-card">
                        <img src={NoraFeatures2} alt="AI Feedback" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>Extremely Realistic Voice Interaction</h3>
                            <p>"Everything is answered through voice... it really feels like you're interviewing with the recruiter."</p>
                        </div>
                    </div>
                    <div className="feature-card">
                        <img src={NoraFeatures3} alt="Any Role" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>No Cap, Here's How You Did</h3>
                            <p>See your mock interview score, your skills gaps, and chat with Nora to level up fast.</p>
                        </div>
                    </div>
                    <div className="feature-card">
                        <img src={NoraFeatures4} alt="Track Progress" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>Tailored Modes for Every Need</h3>
                            <p>Choose the specific type of interview practice you need today.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="cool-homepage-section">
                <h2 className="outsourcing-heading">"This feels like having the interview questions a day before."</h2>
                {!loginState.loggedIn && (
                    <div className="button-container">
                        <button className="nora-button-style"
                            style={{ marginTop: '10px' }}
                            onClick={() => name
                                ? navigate("/login", { state: { referredFrom: referrerId || null, userReferred: true } })
                                : navigate("/login")
                            }>
                            And the interview answers.
                        </button>
                    </div>
                )}
            </div>

            <div className="cta-container" id="testimonials">
                <div className="cta-text">Hear from Applicants like you</div>
            </div>
            <div>
                <Swiper
                    spaceBetween={0}
                    slidesPerView={isMobile ? 1 : 3}
                    modules={[Pagination]}
                    pagination={{ clickable: true }}
                    style={{ margin: 'auto', paddingBottom: '70px', paddingTop: '20px' }}
                >
                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review10}
                                    alt="Nikki J Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Nikki J.</h3>
                                <p className="title">Flight Attendant, United Airlines</p>
                                <p className="quote">
                                    "I had my F2F in 4 days and had no idea what questions 
                                    they'd throw at me. Nora ran me through some passenger situations and 
                                    behavioral questions and two of them literally came up word for word in my actual interview!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review11}
                                    alt="Ali S Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Ali S.</h3>
                                <p className="title">Cabin Crew, Emirates</p>
                                <p className="quote">
                                    "What surprised me was how real it felt. 
                                    It was like an actual back and forth conversation 
                                    like a real recruiter was sitting across from me. Really cool product!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review12}
                                    alt="Alexis M. Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Alexis M.</h3>
                                <p className="title">Flight Attendant, Delta Airlines</p>
                                <p className="quote">
                                    "I kept freezing up when they asked me about difficult passengers. 
                                    Nora made me practice that scenario so many times that when it 
                                    came up in the real interview I just answered it without thinking LOL!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review13}
                                    alt="Nobel A. Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Nobel A.</h3>
                                <p className="title">Cabin Crew, Vietnam Airlines</p>
                                <p className="quote">
                                    "I wasn't expecting the feedback to be that specific. 
                                    It didn't just say 'good answer', it told me exactly which part of my response lost the interviewer and why"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review14}
                                    alt="Imani H. Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Imani H.</h3>
                                <p className="title">Flight Attendant, United Airlines</p>
                                <p className="quote">
                                    "Three days before my interview I had nothing prepared. 
                                    Two days of Nora mock interview sessions and I walked in actually feeling ready. 
                                    Very cool product and highly recommend you check it out!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review15}
                                    alt="Alastair C. Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Alastair C.</h3>
                                <p className="title">Cabin Crew, Air New Zealand</p>
                                <p className="quote">
                                    "I usually panic before interviews and I used this the night before my interview just to calm down!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>

            </div>

            {/* FAQ Section */}
            <div className="faq-section" id="faqs">
                <h2 style={{
                    fontSize: '32px',
                    marginBottom: '25px',
                    fontWeight: '500',
                    fontFamily: "'Lateef', serif",
                    textAlign: 'center'
                }}> Frequently <span style={{ color: '#7D994D' }}> Asked Questions </span> </h2>
                {faqs.map((faq, index) => (
                    <div className="faq-item" key={index}>
                        <button
                            className="faq-question"
                            onClick={() => toggleFAQ(index)}
                        >
                            {faq.question}
                            <span className="arrow">{openIndex === index ? '▼' : '▲'}</span>
                        </button>
                        <div
                            className="faq-answer"
                            ref={el => faqRefs.current[index] = el}
                        >
                            {faq.answer}
                        </div>
                    </div>
                ))}
            </div>

            {/* Company Mock Interview Section */}
            <div>
                <h2 className="company-mock-section-section">Jump start your interview practice now.</h2>
                <CompanyCards />
            </div>

            <div className={isMobile ? "practiceNoraCard-mobile" : "practiceNoraCard"}>
                <div style={{ textAlign: "center" }}>
                    <div className={isMobile ? "practiceNoraCardHead-mobile" : "practiceNoraCardHead"}>Ready to begin mastering interviews with Nora?</div>

                    <button className="nora-button-style"
                        onClick={() => name
                            ? navigate("/login", { state: { referredFrom: referrerId || null, userReferred: true } })
                            : navigate("/login")
                        }>
                        Practice Now
                    </button>
                </div>
            </div>

            <Footer />
        </div>
    </>
    )
}

export default FlightAttendantHomeScreen;